import { AxiosError } from "axios";
import { toast } from "react-toastify";

interface ErrorResponse {
  message: string;
}

export const handleAxiosError = (error: any) => {
  if (error.response) {
    // Handle error with response from server
    toast.error(error.response.data.message || "An error occurred");
  } else if (error.message) {
    // Handle error with a general message
    toast.error(error.message);
  } else {
    toast.error("An error occurred");
  }
};
